import accordionSection, { type AccordionSectionTokens } from './accordionSection/tokens';
import accountPage, { type AccountPageTokens } from './accountPage/tokens';
import actionMenu, { type ActionMenuTokens } from './actionMenu/tokens';
import activitiesMultiselect, { type ActivitiesMultiselectTokens } from './activitiesMultiselect/tokens';
import activityDataValidation, { type ActivityDataValidationTokens } from './activityDataValidation/tokens';
import adminConfigTable, { type AdminConfigTableTokens } from './adminConfigTable/tokens';
import app, { type AppTokens } from './app/tokens';
import appAccordion, { type AppAccordionTokens } from './appAccordion/tokens';
import appActivityDataDetailForm, { type AppActivityDataDetailFormTokens } from './appActivityDataDetailForm/tokens';
import appActivityDataStepSidebar, { type AppActivityDataStepSidebarTokens } from './appActivityDataStepSidebar/tokens';
import appBanner, { type AppBannerTokens } from './appBanner/tokens';
import appCard, { type AppCardTokens } from './appCard/tokens';
import appDataTable, { type AppDataTableTokens } from './appDataTable/tokens';
import appEditableRowTable, { type AppEditableRowTableTokens } from './appEditableRowTable/tokens';
import appEmptyState, { type AppEmptyStateTokens } from './appEmptyState/tokens';
import appEventGroup, { type AppEventGroupTokens } from './appEventGroup/tokens';
import appHeader, { type AppHeaderTokens } from './appHeader/tokens';
import appMenubar, { type AppMenubarTokens } from './appMenubar/tokens';
import appModal, { type AppModalTokens } from './appModal/tokens';
import appRoutedTabsList, { type AppRoutedTabsListTokens } from './appRoutedTabsList/tokens';
import appSection, { type AppSectionTokens } from './appSection/tokens';
import appSeparator, { type AppSeparatorTokens } from './appSeparator/tokens';
import appSignature, { type AppSignatureTokens } from './appSignature/tokens';
import appSplashCard, { type AppSplashCardTokens } from './appSplashCard/tokens';
import appSurface, { type AppSurfaceTokens } from './appSurface/tokens';
import appText, { type AppTextTokens } from './appText/tokens';
import appValueSection, { type AppValueSectionTokens } from './appValueSection/tokens';
import checkRadio, { type CheckRadioTokens } from './checkRadio/tokens';
import controlObjectIdentify, { type ControlObjectIdentifyTokens } from './controlObjectIdentify/tokens';
import controlObjectSummaryCard, { type ControlObjectSummaryCardTokens } from './controlObjectSummaryCard/tokens';
import customBoxShadow, { type CustomBoxShadowTokens } from './customBoxShadow/tokens';
import customPlaceholder, { type CustomPlaceholderTokens } from './customPlaceholder/tokens';
import deficiencyStepTable, { type DeficiencyStepTableTokens } from './deficiencyStepTable/tokens';
import eventCalendar, { type EventCalendarTokens } from './eventCalendar/tokens';
import eventInputState, { type EventInputStateTokens } from './eventInputState/tokens';
import fileUploadZone, { type FileUploadZoneTokens } from './fileUploadZone/tokens';
import groupedTable, { type GroupedTableTokens } from './groupedTable/tokens';
import idleSessionModal, { type IdleSessionModalTokens } from './idleSessionModal/tokens';
import incidentModal, { type IncidentModalTokens } from './incidentModal/tokens';
import inspectionOtherParticipantModal, {
	type InspectionOtherParticipantModalTokens,
} from './inspectionOtherParticipantModal/tokens';
import inspectionParticipantCard, { type InspectionParticipantCardTokens } from './inspectionParticipantCard/tokens';
import inspectionParticipantSection, {
	type InspectionParticipantSectionTokens,
} from './inspectionParticipantSection/tokens';
import inspectionReportViolationsSection, {
	type InspectionReportViolationsSectionTokens,
} from './inspectionReportViolationsSection/tokens';
import inspectionRepresentativeModal, {
	type InspectionRepresentativeModalTokens,
} from './inspectionRepresentativeModal/tokens';
import inspectionStepBlockedView, { type InspectionStepBlockedViewTokens } from './inspectionStepBlockedView/tokens';
import inspectionStepPageTitle, { type InspectionStepPageTitleTokens } from './inspectionStepPageTitle/tokens';
import inspectionTables, { type InspectionTablesTokens } from './inspectionTables/tokens';
import inspectionTag, { type InspectionTagTokens } from './inspectionTag/tokens';
import inspectionValidationSummary, {
	type InspectionValidationSummaryTokens,
} from './inspectionValidationSummary/tokens';
import notificationModal, { type NotificationModalTokens } from './notificationModal/tokens';
import participantSignatureModal, { type ParticipantSignatureModalTokens } from './participantSignatureModal/tokens';
import pdfViewer, { type PdfViewerTokens } from './pdfViewer/tokens';
import platinum, { type PlatinumTokens } from './platinum/tokens';
import presetText, { type PresetTextTokens } from './presetText/tokens';
import questionnaireStep, { type QuestionnaireStepTokens } from './questionnaireStep/tokens';
import reportStatusTag, { type ReportStatusTagTokens } from './reportStatusTag/tokens';
import userInfo, { type UserInfoTokens } from './userInfo/tokens';

/** Every app token group, keyed by the name that prefixes its variables (`--p-<group>-…`). */
export type AppExtendTokens = {
	app: AppTokens;
	activityDataValidation: ActivityDataValidationTokens;
	appActivityDataDetailForm: AppActivityDataDetailFormTokens;
	appActivityDataStepSidebar: AppActivityDataStepSidebarTokens;
	appBanner: AppBannerTokens;
	platinum: PlatinumTokens;
	appSignature: AppSignatureTokens;
	inspectionStepBlockedView: InspectionStepBlockedViewTokens;
	inspectionStepPageTitle: InspectionStepPageTitleTokens;
	inspectionParticipantCard: InspectionParticipantCardTokens;
	inspectionParticipantSection: InspectionParticipantSectionTokens;
	controlObjectSummaryCard: ControlObjectSummaryCardTokens;
	controlObjectIdentify: ControlObjectIdentifyTokens;
	inspectionOtherParticipantModal: InspectionOtherParticipantModalTokens;
	inspectionRepresentativeModal: InspectionRepresentativeModalTokens;
	inspectionReportViolationsSection: InspectionReportViolationsSectionTokens;
	incidentModal: IncidentModalTokens;
	inspectionValidationSummary: InspectionValidationSummaryTokens;
	appHeader: AppHeaderTokens;
	appModal: AppModalTokens;
	actionMenu: ActionMenuTokens;
	appAccordion: AppAccordionTokens;
	accordionSection: AccordionSectionTokens;
	presetText: PresetTextTokens;
	customPlaceholder: CustomPlaceholderTokens;
	customBoxShadow: CustomBoxShadowTokens;
	inspectionTables: InspectionTablesTokens;
	appDataTable: AppDataTableTokens;
	appEditableRowTable: AppEditableRowTableTokens;
	deficiencyStepTable: DeficiencyStepTableTokens;
	appSection: AppSectionTokens;
	appCard: AppCardTokens;
	appEmptyState: AppEmptyStateTokens;
	groupedTable: GroupedTableTokens;
	activitiesMultiselect: ActivitiesMultiselectTokens;
	appValueSection: AppValueSectionTokens;
	appMenubar: AppMenubarTokens;
	participantSignatureModal: ParticipantSignatureModalTokens;
	appEventGroup: AppEventGroupTokens;
	appSplashCard: AppSplashCardTokens;
	fileUploadZone: FileUploadZoneTokens;
	questionnaireStep: QuestionnaireStepTokens;
	eventCalendar: EventCalendarTokens;
	reportStatusTag: ReportStatusTagTokens;
	appText: AppTextTokens;
	appSurface: AppSurfaceTokens;
	appSeparator: AppSeparatorTokens;
	checkRadio: CheckRadioTokens;
	pdfViewer: PdfViewerTokens;
	inspectionTag: InspectionTagTokens;
	notificationModal: NotificationModalTokens;
	idleSessionModal: IdleSessionModalTokens;
	eventInputState: EventInputStateTokens;
	adminConfigTable: AdminConfigTableTokens;
	appRoutedTabsList: AppRoutedTabsListTokens;
	accountPage: AccountPageTokens;
	userInfo: UserInfoTokens;
};

export const extend = {
	app,
	activityDataValidation,
	appActivityDataDetailForm,
	appActivityDataStepSidebar,
	appBanner,
	platinum,
	appSignature,
	inspectionStepBlockedView,
	inspectionStepPageTitle,
	inspectionParticipantCard,
	inspectionParticipantSection,
	controlObjectSummaryCard,
	controlObjectIdentify,
	inspectionOtherParticipantModal,
	inspectionRepresentativeModal,
	inspectionReportViolationsSection,
	incidentModal,
	inspectionValidationSummary,
	appHeader,
	appModal,
	actionMenu,
	appAccordion,
	accordionSection,
	presetText,
	customPlaceholder,
	customBoxShadow,
	inspectionTables,
	appDataTable,
	appEditableRowTable,
	deficiencyStepTable,
	appSection,
	appCard,
	appEmptyState,
	groupedTable,
	activitiesMultiselect,
	appValueSection,
	appMenubar,
	participantSignatureModal,
	appEventGroup,
	appSplashCard,
	fileUploadZone,
	questionnaireStep,
	eventCalendar,
	reportStatusTag,
	appText,
	appSurface,
	appSeparator,
	checkRadio,
	pdfViewer,
	inspectionTag,
	notificationModal,
	idleSessionModal,
	eventInputState,
	adminConfigTable,
	appRoutedTabsList,
	accountPage,
	userInfo,
} satisfies AppExtendTokens;
